import { render, staticRenderFns } from "./CoassDetails.vue?vue&type=template&id=643d9046&"
import script from "./CoassDetails.vue?vue&type=script&lang=js&"
export * from "./CoassDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports